import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import Toolbar, { Item } from "devextreme-react/toolbar";
import FormField from '../../dynamicFormBuilder/FormField';
import SearchLayout from './ApiAuditLogSearchLayout';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../assets/apiRoutes.json";
import {
  Column,
  DataGrid,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  Export,
  ColumnChooser,
  ColumnChooserSearch,
  MasterDetail,
  StateStoring,
  Toolbar as GridToolbar,
  Item as GridToolbarItem,
} from "devextreme-react/data-grid";
import { GridLayout } from '../../common/GridLayout';
import GridLayoutManager from '../../gridLayoutCustomization/GridLayoutManager';
import '../../common/css/searchPage.css';

const searchpanel = [{ ID: 1, Title: 'Search Filters' }];

const levelOptions = [
  { ID: "Request", Name: "Request" },
  { ID: "Response", Name: "Response" },
  { ID: "Error", Name: "Error" },
];

const initialFormFields = {
  UserName: '',
  StatusCode: '',
  Level: '',
  DateFrom: null,
  DateTo: null,
  Message: '',
  DurationSeconds: '',
  IpAddress: '',
  Properties: '',
  Exception: '',
};

const ApiAuditLogs = (props) => {
  const dataGrid = useRef(null);
  const accessToken = props.oidc.user.access_token;
  const currentUser = props.oidc.user;
  const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const formRefs = useRef({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [formFields, setFormFields] = useState(initialFormFields);
  const [resultData, setResultData] = useState(null);
  const allowedPageSizes = [10, 20, 100, 500, 1000];

  const gridKey = "f3c9a1e2-7b4d-4c8a-9e6f-2d1a5b8c3e7f";
  const [currentLayout, setCurrentLayout] = useState("Default");
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

  const handleFieldChange = useCallback((name, value) => {
    // placeholder for field-level business rules
  }, []);

  // Populate the dynamic-form select boxes once the form layout has loaded.
  const handleFormLoad = useCallback(() => {
    if (formRefs.current["Level"]) {
      const options = levelOptions.map((o) => ({ id: o.ID, name: o.Name }));
      formRefs.current["Level"].instance().option("dataSource", options);
      formRefs.current["Level"].instance().option("valueExpr", "id");
      formRefs.current["Level"].instance().option("displayExpr", "name");
    }
  }, []);

  const loadDatasource = () => {
    const url = data.ApiLog.getApiLogs;
    const store = createStore({
      key: 'id',
      loadParams: formFields,
      loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });
    const dataSource = new DataSource({ store });
    return dataSource;
  };

  const buildFilters = () => {
    const filters = [];
    const push = (expr) => {
      if (filters.length > 0) filters.push("and");
      filters.push(expr);
    };

    if (formFields.UserName) push(["UserName", "contains", formFields.UserName]);
    if (formFields.Level) push(["Level", "=", formFields.Level]);
    if (formFields.StatusCode) push(["StatusCode", "=", parseInt(formFields.StatusCode, 10)]);
    if (formFields.DateFrom) push(["TimeStamp", ">=", formFields.DateFrom]);
    if (formFields.DateTo) push(["TimeStamp", "<=", formFields.DateTo]);
    if (formFields.Message) push(["Message", "contains", formFields.Message]);
    if (formFields.DurationSeconds) push(["DurationSeconds", "=", parseInt(formFields.DurationSeconds, 10)]);
    if (formFields.IpAddress) push(["IpAddress", "contains", formFields.IpAddress]);
    if (formFields.Properties) push(["Properties", "contains", formFields.Properties]);
    if (formFields.Exception) push(["Exception", "contains", formFields.Exception]);

    return filters;
  };

  const handleSearch = (e) => {
    e.event.stopPropagation();
    const datasource = loadDatasource();
    const filters = buildFilters();
    if (filters && filters.length > 0) {
      datasource.filter(filters);
    }
    setResultData(datasource);
  };

  const handleReset = (e) => {
    e.event.stopPropagation();
    setFormFields(initialFormFields);
    const datasource = loadDatasource();
    setResultData(datasource);
  };

  const selectionChanged = useCallback((e) => {
    let newItems = [...selectedItems];
    e.removedItems.forEach((item) => {
      const index = newItems.indexOf(item);
      if (index >= 0) newItems.splice(index, 1);
    });
    if (e.addedItems.length) newItems = [...newItems, ...e.addedItems];
    setSelectedItems(newItems);
  }, [selectedItems]);

  useEffect(() => {
    const datasource = loadDatasource();
    setResultData(datasource);
  }, []);

  const DetailView = ({ data: row }) => {
    const log = row.data;
    return (
      <div style={{ marginTop: '5px' }}>
        <b>Properties</b>
        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', background: '#f7f7f7'}}>
          {log.properties || '(none)'}
        </pre>
        {log.exception ? (
          <>
            <b>Exception</b>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', background: '#fff0f0' }}>
              {log.exception}
            </pre>
          </>
        ) : null}
      </div>
    );
  };

  return (
    <div className="search-page-container">
      <div className="search-page-content">
        <div id="accordion" className="search-page-accordion">
          <AccordionReact
            dataSource={searchpanel}
            collapsible={true}
            multiple={false}
            animationDuration={300}
            selectedItems={selectedItems}
            onSelectionChanged={(e) => {
              if (e.currentTarget === e.target) {
                selectionChanged(e);
              }
            }}
            itemTitleRender={() => (
              <Toolbar className="accordian-toolbar">
                <Item location="before">
                  <div className="title">
                    <h6 style={{ color: window._env_.Color2 }}>API Audit Logs</h6>
                  </div>
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={handleReset} text="Reset" />
                </Item>
              </Toolbar>
            )}
            itemRender={() => (
              <FormField
                currrentUser={currentUser}
                layoutId='b2f7e1d4-3a6c-4e9b-8f1a-7c5d2e8a4b91'
                layoutName='ApiAuditLogSearchForm'
                defaultFormSchema={SearchLayout}
                formFields={formFields}
                setformFields={setFormFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleFormLoad}
                noSpacingBeforeFirstRow={true}
              />
            )}
            id="accordion-container" className="accordion-height"
          />
        </div>
        <div className="search-page-grid-container">
          <DataGrid
            onExporting={(e) => {
              if (window.handleDevExtremeDataGridExport) {
                window.handleDevExtremeDataGridExport(e);
              }
            }}
            ref={dataGrid}
            allowColumnReordering={true}
            allowColumnResizing={true}
            dataSource={resultData}
            showBorders={true}
            hoverStateEnabled={true}
            className="search-page-grid"
            remoteOperations={true}
            columnAutoWidth={true}
          >
            <StateStoring
              enabled={true}
              type="custom"
              customLoad={loadState}
              storageKey={gridKey}
              customSave={saveState}
            />
            <ColumnChooser enabled={true} title="Choose Column" width={290} height={290} sortOrder="asc">
              <ColumnChooserSearch enabled={true} editorOptions={{ placeholder: 'Search column' }} />
            </ColumnChooser>
            <Export enabled={true} allowExportSelectedData={true} />
            <Sorting visible={true} mode="multiple" />
            <Paging defaultPageSize={20} />
            <Pager visible={true} showPageSizeSelector={true} allowedPageSizes={allowedPageSizes} showNavigationButtons={true} />
            <FilterRow visible={true} />
            <FilterPanel visible={true} />
            <HeaderFilter visible={true} />
            <MasterDetail enabled={true} component={DetailView} />
            <Column dataField="level" caption="Level" />
            <Column dataField="timeStamp" caption="Timestamp" dataType="date" format="MM/dd/yyyy hh:mm:ss aa" defaultSortOrder="desc" defaultSortIndex={0} />
            <Column dataField="userName" caption="User" />
            <Column dataField="statusCode" caption="Status" dataType="number" />
            <Column dataField="durationSeconds" caption="Duration (s)" dataType="number" />
            <Column dataField="ipAddress" caption="IP Address"  />
            <Column dataField="message" caption="Message" />
            <GridToolbar>
              <GridToolbarItem location="after">
                <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
              </GridToolbarItem>
              <GridToolbarItem name="exportButton" />
              <GridToolbarItem name="columnChooserButton" />
            </GridToolbar>
          </DataGrid>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    oidc: state.oidc
  };
}

export default connect(mapStateToProps)(ApiAuditLogs);
